import {StyleSheet, css} from 'aphrodite';
import React from 'react';

import Tooltip from 'ui-library/bs/Tooltip';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import {GRAY_DARK} from 'ui-library/Colors';

interface ToggleAnalysisSidebarButtonProps {
  sidebarIsOpen: boolean;
  toggleSidebar: () => void;
}

export default function ToggleAnalysisSidebarButton({
  sidebarIsOpen,
  toggleSidebar: toggleSidebarOpen,
}: ToggleAnalysisSidebarButtonProps): JSX.Element {
  return (
    <Tooltip title={sidebarIsOpen ? 'Close sidebar' : 'Open sidebar'}>
      <Button
        buttonStyle={ButtonStyle.TERTIARY_WHITE}
        className={css(styles.button)}
        icon={sidebarIsOpen ? 'chevron-left' : 'chevron-right'}
        onClick={() => {
          toggleSidebarOpen();
        }}
        size={ButtonSize.SMALL}
        dataTestAttrs={{component: 'ToggleAnalysisSidebarButton', element: 'root'}}
      />
    </Tooltip>
  );
}

const styles = StyleSheet.create({
  button: {
    fontSize: 16,
    color: GRAY_DARK,
  },
});
